import { render, staticRenderFns } from "./customerProperties.vue?vue&type=template&id=64edf56c"
import script from "./customerProperties.ts?vue&type=script&lang=js&external"
export * from "./customerProperties.ts?vue&type=script&lang=js&external"
import style0 from "./customerProperties.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports